import React from "react";
import { connect } from "react-redux";
import { movil } from "../app-movil";

const mapState = (state) => {
	return {
		paso: state.miPerfil.pasoCodigo
	};
};

const mapDispatch = (dispatch) => {
	return {
		resetPaso: () => {
			dispatch({ "type": "MI_PERFIL_RESET_SIGUIENTE_CODIGO" });
		},
		addEvento: (evento) => {
			dispatch({ "type": "MI_PERFIL_SET_EVENT", "evento": evento});
		}
	};
};

class PasoDosCodigo extends React.Component {
	state = {}

	ok = () => {
		this.props.resetPaso();
		$("#modal-codigo-dp").modal("toggle");
		this.props.addEvento("DatosActualizados-CodigoOTP-DP");

		let mensaje = {"return": "miPerfil", "proceso": "modal-codigo-dp"};
		movil("modal-codigo-dp", mensaje);
		
	}

	render() {
		return <div>
			<h5>
				<i>
					<img src={ require("../img/code-icon.png") } />
				</i>Autorización exitosa
			</h5>
			<hr className="mt-34" />
			<div className="texto-17">
				<p>¡Listo! Tus datos han sido actualizados satisfactoriamente.</p>
			</div>
			<div className="row">
				<div className="col-xs-12">
					<div className="text-center aceptar-cancelar-btn mt-50">
						<a name="okCodigo" onClick={this.ok} className="orange-btn">Aceptar</a>
					</div>
				</div>
			</div>
		</div>
	}
}

export default connect(mapState, mapDispatch)(PasoDosCodigo);


// WEBPACK FOOTER //
// ./src/miPerfil/pasoDosCodigo.cmpt.js